import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'roblex-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent implements OnInit {
    /**
     * Input value of progress component
     */
    @Input() value: number = 0;
    /**
     * Input level of progress component
     */
    @Input() level!: string;
    /**
     * Input start of progress component
     */
    @Input() start!: string;
    /**
     * Input end of progress component
     */
    @Input() end!: string;
    /**
     * Input description of progress component
     */
    @Input() description!: string;
    /**
     * Input has information of progress component
     */
    @Input() hasInformation: boolean = true;
    /**
     * Output clicked information of progress component
     */
    @Output() clickedInformation: EventEmitter<void> = new EventEmitter<void>();
    /**
     * Creates an instance of progress component.
     */
    constructor() {}
    /**
     * on init
     */
    ngOnInit(): void {}
    /**
     * Determines whether click information on
     */
    onClickInformation() {
        this.clickedInformation.emit();
    }
}
